import { useEffect, useState } from 'react';
import { GALLERY } from './data';

// Photos the owner manages from /admin. The site asks the photo service what
// is published; if that call fails for any reason the built-in images below
// are used instead, so a service outage can never leave the page blank.

const HERO_FALLBACK = [
  { src: '/pexels-goochie-poochie-19145889.webp', alt: 'A dog being groomed at Bubbles & Bark' },
];

const imgUrl = (id) => `/api/photos/img/${id}`;

export function usePhotos() {
  const [photos, setPhotos] = useState({
    hero: HERO_FALLBACK,
    gallery: GALLERY,
  });

  useEffect(() => {
    let cancelled = false;

    const toList = (raw, fallback, fallbackAlt) => {
      const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
      if (!list.length) return fallback;
      return list.map((p) => ({ src: imgUrl(p.id), alt: p.alt || fallbackAlt }));
    };

    fetch('/api/photos', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setPhotos({
          hero: toList(data.hero, HERO_FALLBACK, HERO_FALLBACK[0].alt),
          gallery: toList(data.gallery, GALLERY, ''),
        });
      })
      .catch(() => {
        /* keep the fallback */
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return photos;
}

/** Step through a list on a timer. Returns 0 for a list of one, so a single
 *  photo never animates and never re-renders. */
export function useRotator(length, ms = 5000) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (length < 2) {
      setI(0);
      return undefined;
    }
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return undefined;

    const t = setInterval(() => setI((n) => (n + 1) % length), ms);
    return () => clearInterval(t);
  }, [length, ms]);

  return Math.min(i, Math.max(0, length - 1));
}
